import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, IconDownload } from "@veneer/core";
import { useTranslation } from "react-i18next";
import { AdminNotIndividualRole } from "utils";

interface ExcelType {
  rows: Record<string, any>[]; // Array of objects
  fileName?: string;
}

const ExportToExcelColor: React.FC<ExcelType> = ({ fileName, rows }) => {
  const { t } = useTranslation();
  const title = fileName || "all_cases.xlsx";

  const exportToExcel = async () => {
    if (!rows || rows.length === 0) {
      console.warn("No data to export.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    //const headers = Object.keys(rows[0]);
    const headers = [
      "Case ID",
      "Case title",
      "Case status",
      "Case Priority",
      "Submitted By",
      "Serial Number",
      "Product Number",
      "Site-account",
      "Internal Tracking number",
      "Date submitted",
      "Last updated",
    ];
    if (AdminNotIndividualRole) {
      headers.push("Bulk Id"); // Add Bulk Upload header if AdminNotIndividualRole is true
    }
    worksheet.addRow(headers);

    // Add data rows
    rows.forEach((row) => {
      const rowData = headers.map((key) => row[key]);
      const newRow = worksheet.addRow(rowData);

      // Apply text color based on "Case status"
      const caseStatusIndex = headers.indexOf("Case status");
      const casePriorityIndex = headers.indexOf("Case Priority");
      if (caseStatusIndex !== -1) {
        const caseStatusCell = newRow.getCell(caseStatusIndex + 1);
        const casePriorityCell = newRow.getCell(casePriorityIndex + 1);
        let textvalue = row?.statecodeid || "";
        if (textvalue === "100000001") {
          caseStatusCell.font = { color: { argb: "fdb700" } };
          casePriorityCell.font = { color: { argb: "fdb700" } }; //"orange";
        } else if (textvalue === "925250000") {
          caseStatusCell.font = { color: { argb: "008000" } };
          casePriorityCell.font = { color: { argb: "008000" } }; //"green";
        } else if (textvalue === "925250001") {
          caseStatusCell.font = { color: { argb: "001cbf" } };
          casePriorityCell.font = { color: { argb: "001cbf" } }; //"Blue ";
        }
      }
    });

    // Generate Excel file and trigger download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, title);
  };

  return (
    <Button leadingIcon={<IconDownload />} onClick={exportToExcel}>
      {t("HPI.ExportToExcel", { defaultValue: "Export To Excel" })}
    </Button>
  );
};

export default ExportToExcelColor;
